(ns machtfit.stepchall.activity-log
  (:require [clojure.string :as str]
            [com.rpl.specter :as sp]
            [machtfit.app.routes :as routes]
            [machtfit.format :as format]
            [machtfit.stepchall.api :as api]
            [machtfit.stepchall.date :as date]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [tr t]]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::activity-delete-clicked
  (fn [{:keys [db]} [_ id]]
    (let [stats-date (date/stats-date db)]
      {:db (sp/setval [:stepchall :participant :recent-activities
                       stats-date
                       sp/ALL #(= (:id %) id) :deleted?]
                      true db)
       :post (api/request db {:function :stepchall-delete-activity
                              :params {:activity_id id}})})))

(rf/reg-event-fx ::activity-undelete-clicked
  (fn [{:keys [db]} [_ id]]
    (let [stats-date (date/stats-date db)]
      {:db (sp/setval [:stepchall :participant :recent-activities
                       stats-date
                       sp/ALL #(= (:id %) id) :deleted?]
                      false db)
       :post (api/request db {:function :stepchall-undelete-activity
                              :params {:activity_id id}})})))

(defn- activity-log-item [{:keys [activity id #_:clj-kondo/ignore count deleted? data-source]}]
  (let [{:keys [name unit factor]} @(rf/subscribe [::subs/activity-data activity])
        count-in-steps (* count factor)
        unit-name @(rf/subscribe [::subs/unit-name unit])
        unit-is-main-unit? (= unit :steps)
        unit-is-steps? (-> unit-name :en str/lower-case (= "steps"))
        main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    [:div.sc_activity-log-item {:class (when deleted? "deleted")}
     [:div
      [:h3 (t (if data-source
                {:de data-source
                 :en data-source}
                name))]
      [:p
       [:i.sc_icon (if unit-is-steps? [icons/steps] [icons/timer])]
       [:span (str count " " (t unit-name))]
       (when-not unit-is-main-unit?
         [:span.sc_primary-color (str " (" (format/decimal count-in-steps) " " (t main-unit-plural) ")")])]]
     (when (nil? data-source)
       [:div
        (if deleted?
          [:button {:on-click #(rf/dispatch [::activity-undelete-clicked id])} [:i.sc_icon [icons/undo]]]
          [:button {:on-click #(rf/dispatch [::activity-delete-clicked id])} [:i.sc_icon [icons/close]]])])]))

(rf/reg-sub ::participant-recent-activities
  :<- [::date/stats-date]
  :<- [:get [:stepchall :participant :recent-activities]]

  (fn [[date activities] _]
    (activities date)))

(defn activity-log []
  (let [stats-date @(rf/subscribe [::date/stats-date])]
    (when-not (= stats-date :all)
      [:div.sc_activity-log
       [:a.sc_btn.sc_btn-lg.sc_btn-primary-ghost
        (routes/attrs-link-to-page {:id :stepchall
                                    :subpage :select-activity
                                    :entry-date (format/keyword->date stats-date)})
        [:i.sc_icon [icons/plus]] (tr "Aktivität hinzufügen")]
       [:div.sc_activity-log-list
        (for [activity @(rf/subscribe [::participant-recent-activities])]
          ^{:key (:id activity)} [activity-log-item activity])]])))
